import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AssetConnection } from '../../../services/types/events';

export interface EventsState {
  isEventMode: boolean;
  selectedEventId?: string;
  eventAssets: Record<string, AssetConnection | null>; // eventId -> AssetConnection
}

const initialState: EventsState = {
  isEventMode: false,
  selectedEventId: undefined,
  eventAssets: {},
};

export const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setIsEventMode(state, action: PayloadAction<boolean>) {
      state.isEventMode = action.payload;
    },
    setSelectedEventId(state, action: PayloadAction<string | undefined>) {
      state.selectedEventId = action.payload;
    },
    setEventAssets(state, action: PayloadAction<{ eventId: string; assets: AssetConnection | null }>) {
      state.eventAssets[action.payload.eventId] = action.payload.assets;
    },
  },
});

export const { setIsEventMode, setSelectedEventId, setEventAssets } = eventsSlice.actions;

export default eventsSlice.reducer;


